import React from 'react'
import { Div, P, Strong } from '@driftt/tide-core'
import { Table } from '@driftt/tide-table'
import { Icon } from '@driftt/tide-icons'

import './style.css'

const ImportInstructions = () => (
  <Div className="account-import-instructions">
    <Div>
      <Icon height={34} width={34} name="email-2-at" />
      <Strong>Account owners must be in Drift</Strong>
      <P>Account owners need to match the email address of a teammate in Drift. If it doesn’t match, that account won’t be imported.</P>
    </Div>
    <Div>
      <Icon height={36} width={36} name="rolodex" />
      <Strong>All accounts must have</Strong>
      <Table
        columns={[{label: 'Name'}, {label: 'Domain'}, {label: 'Account Owner'}]}
        data={[{ data: [{content: 'Drift'}, {content: 'drift.com'}, {content: 'jose@gmail.com'}]}]}
      />
      <P></P>
    </Div>
    <Div>
      <Icon height={40} name="list-bullets" />
      <Strong>Drift won't import duplicate accounts</Strong>
      <P>If we find an exact match on an account that already exists, we won’t import them again.</P>
    </Div>
  </Div>
)

export default ImportInstructions
